/**
 * Created by Alexey Galkevych on 07.12.2021.
 */
import Swiper from 'swiper/bundle';
import wishlist from '../modules/WishList';
import ProductCompare from "./ProductCompare";
import { blockEl, unblockEl } from "./Block";
import MobileSlider from "./MobileSlider";
const { __ } = wp.i18n;


export default class AjaxGetProducts {
  constructor(options) {
    this.options = options;
    this.wrapper = options.wrapper;
    this.context = this.getContext();
    this.loadMore = options.loadMore;
    this.ids = this.getIds();
    this.page = 0;
    this.max_pages = 0;
    this.total = 0;
    this.min = 'compare' === this.options.type ? 2 : 1;
    this.compareSlider = null;

    if(this.ids.length < this.min) {
      this.renderNoProducts(this.options.type);
    }

    //if no ids or no wrapper - stop
    if(![this.wrapper, this.ids].every( value => !! value )) {
      return false;
    }

    this.attachHandlers();
    this.renderProducts();
  }

  attachHandlers()
  {
    if(this.loadMore) {
      const btn = this.loadMore.querySelector('.btn');
      btn.addEventListener('click', this.renderProducts.bind(this));
    }

    document.body.addEventListener('wishlist_products_loaded', this.mayBeInitSliders.bind(this));
    document.body.addEventListener('compare_products_loaded', this.maybeInitCompareSlider.bind(this));
    document.body.addEventListener('compare_products_loaded', this.showCompareHeadings.bind(this));

    this.wrapper.addEventListener('click', event => {
      let button;
      let className = '';

      if('wishlist' === this.options.type) {
        className = 'btn-wishlist-remove';
      } else if('compare' === this.options.type) {
        className = 'btn-compare-remove';
      }
      if(event.target.classList.contains(className)) {
        button = event.target;
      } else if(event.target.parent && event.target.parent.classList.contains('btn-wishlist-remove')) {
        button = event.target.parent;
      }

      if( !button ) {
        return;
      }

      event.preventDefault();
      if('wishlist' === this.options.type) {
         this.removeFromWishlist(button);
      } else if('compare' === this.options.type) {
         this.removeFromCompare(button);
      }
    });

  }

  getContext()
  {
    switch (this.options.type) {
      case 'wishlist':
        return wishlist;
      case 'compare':
        return new ProductCompare();
      default:
        return null;
    }
  }

  getIds()
  {
    if(!this.context) {
      return [];
    }

    return this.context.getIds();
  }

  async renderProducts(data = {})
  {
    if(this.ids.length < this.min) {
      return;
    }

    const {
      ajaxUrl,
      action,
      type,
      secure
    } = this.options;

    data = {...{
      action,
      type,
      secure,
      lang: palram.lang,
      ids: this.ids,
      page: this.page,
    }, ...data};

    if('compare' === this.options.type) {
      data.limit = this.context.limit;
    }

    try {
      const response = await this.getProducts(ajaxUrl, data, {
        beforeSend: this.beforeRequest,
      });

      if(response.success) {
        const {
          content,
          total,
          page,
          max_num_pages,
        } = response.data;

        this.wrapper.insertAdjacentHTML('beforeend', content);

        this.total = total;
        this.page = page;
        this.max_pages = max_num_pages;

        if(this.loadMore) {
          if (this.page < this.max_pages) {
            this.loadMore.removeAttribute('style');
          } else {
            this.loadMore.style.display = 'none';
          }
        }

        // if('wishlist' === this.options.type) {
        //   //init sliders
        //   this.mayBeInitSliders();
        // } else if('compare' === this.options.type) {
        //   this.maybeInitCompareSlider();
        //   this.showCompareHeadings();
        // }

        document.body.dispatchEvent(new CustomEvent(`${this.options.type}_products_loaded`));

        //check if we have wrong values
        if(this.ids.length !== total) {
          this.removeWrongIds();
        }
      }
    } catch (e) {
      return null;
    } finally {
      this.afterRequest();
    }
  }

  beforeRequest = () =>
  {
    blockEl(this.wrapper);

    if(this.loadMore) {
      this.loadMore.disabled = true;
    }
  }

  afterRequest()
  {
    unblockEl(this.wrapper);

    if(this.loadMore) {
      this.loadMore.disabled = false;
    }
  }

  async getProducts(url, data, options = {})
  {
    options = {...{
        url,
        data,
        method: 'GET',
      },...options};
      return $.ajax(options);
  }

  renderNoProducts(type)
  {
    let msg = '';

    if('wishlist' === type) {
      msg = __( 'No products in Your wishlist.', 'canopia' );
    } else if('compare' === type) {
      msg = __('Select 2 to 4 Items to Compare', 'canopia');
    }

    this.wrapper.innerHTML = `<p class="col-12 no-products-${type} woocommerce-info">${msg}</p>`;
  }

  async removeWrongIds()
  {
    const {
      ajaxUrl,
      secure
    } = this.options;
    const data = {
      action: 'palram_products_diff',
      secure,
      ids: this.ids,
    }
    const response = await this.getProducts(ajaxUrl, data);

    if(response.success && response.data.diff.length > 0) {

      response.data.diff.forEach(id => {
        this.context.remove(id);
      });
      //Update ids;
      this.ids = this.getIds();
    }
  }

  removeFromWishlist(button)
  {
    this.removeProduct(button);
    wishlist.remove(button.dataset.productId);
    //Update IDs
    this.ids = this.getIds();

    if(this.ids.length === 0) {
      this.renderNoProducts('wishlist');
    }

    //Get next product if needed
    if (this.page < this.max_pages) {
      //We need to get last product from current page, so decrease page number
      this.page--;
      this.renderProducts({
        get_one: true,
      });
    }
  }

  removeFromCompare(button)
  {
    this.removeProduct(button);
    this.context.remove(button.dataset.productId);

    //May be update slider
    if(this.compareSlider && !this.compareSlider.breakpoint.matches) {
      this.compareSlider.slider.update();
    }

    //Update IDs
    this.ids = this.getIds();

    if(this.ids.length < this.min) {
      this.renderNoProducts('compare');
      this.hideCompareHeadings();
    }
  }

  removeProduct(child)
  {
    const product = child.closest('.product');
    if(product) {
      product.remove();
    }
  }

  mayBeInitSliders() {
    const sliders = document.querySelectorAll('.swiper');
    if(!sliders || sliders.length === 0 ) {
      return;
    }

    sliders.forEach( slider => {
      if(slider.classList.contains('swiper-initialized')) {
        return;
      }
      new Swiper(slider, {
        loop: true,
        centeredSlides: true,
        spaceBetween: 15,
        breakpoints: {
          768: {
            spaceBetween: 0,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
          },
        },
      });

    })
  }

  showCompareHeadings()
  {
    let headings = document.querySelector('.compare-table__headings');

    if(headings) {
      headings.classList.add('d-xl-flex');
    }
  }

  hideCompareHeadings()
  {
    let headings = document.querySelector('.compare-table__headings');

    if(headings) {
      headings.classList.remove('d-xl-flex');
    }
  }

  maybeInitCompareSlider()
  {
    let breakpoint = 'min-width: 1200px';
    this.compareSlider = new MobileSlider(breakpoint, '.compare-list', {
      createElements: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      loop: false,
      spaceBetween: 25,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        bulletClass: 'pagination-bullet compare-bullet',
        clickable: true,
        bulletActiveClass: 'active',
      },
      breakpoints: {
        576: {
          slidesPerView: 2,
          centeredSlides: false,
        },
        992: {
          slidesPerView: 3,
          centeredSlides: true,
        },
      },
    });
  }
}
